import { render } from "./PlantComponentsSection.vue?vue&type=template&id=732fbc87&ts=true"
import script from "./PlantComponentsSection.vue?vue&type=script&lang=ts"
export * from "./PlantComponentsSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__